import { render, staticRenderFns } from "./chatPopover.vue?vue&type=template&id=409fed01&scoped=true"
import script from "./chatPopover.vue?vue&type=script&lang=js"
export * from "./chatPopover.vue?vue&type=script&lang=js"
import style0 from "./chatPopover.vue?vue&type=style&index=0&id=409fed01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409fed01",
  null
  
)

export default component.exports